import { render } from "./SearchContacts.vue?vue&type=template&id=09242a48"
import script from "./SearchContacts.vue?vue&type=script&lang=js"
export * from "./SearchContacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__